import {Dialog, Box} from '@mui/material'
import styled from 'styled-components'
import theme from '../../styles/theme'

export const StyledDialog = styled(Dialog)``

export const DialogBox = styled(Box)`
  width: 1024px;
  overflow-x: hidden;
  box-sizing: border-box;

  && #header-bar {
    display: none;
  }

  && #proxy-renderer {
    overflow-y: hidden !important;
  }

  ${theme.breakpoints.down('sm')} {
    width: 100%;
  }

  ${theme.breakpoints.down('xs')} {
    width: auto;
  }
`
